<template>
	<div class="sv-coin-card">
		<div v-if="coin" class="sv-card-header" :style="{ 'background-color': coin.color }">{{ coin.name }}</div>

		<div class="sv-card-body">
			<div class="from-to">
				<div class="from">
					<common-avatar
						:name="from.name"
						:staffId="from.id"
						:teamId="from.id"
						:image="from.avatar"
						:clickable="clickable"
					></common-avatar>
					<div class="bold18 card-name" ref="card_name_from">
						<div style="white-space: nowrap"><span style="display: inline-block" ref="card_name_sei_from">{{ from.name_sei }}</span></div>
						<div style="white-space: nowrap"><span style="display: inline-block" ref="card_name_mei_from">{{ from.name_mei }}</span></div>
					</div>
				</div>

				<div v-if="coin" class="coin">
					<img class="common-coin-image" :src="coin.image"/>
					<img :src="require('@/assets/coin_present_arrow.svg')"/>
				</div>

				<div class="to">
					<common-avatar
						:isTeam="isTeam"
						:isMember="isMember"
						:name="to.name"
						:staffId="to.id"
						:teamId="to.id"
						:image="to.avatar"
						:clickable="clickable"
					></common-avatar>
					<div v-if="isTeam">
						<div class="bold18 card-name">{{ to.name }}</div>
					</div>
					<div v-else-if="isMember">
						<div class="bold18 card-name">{{ to.name }}</div>
					</div>
					<div v-else>
						<div class="bold18 card-name" ref="card_name_to">
							<div style="white-space: nowrap"><span style="display: inline-block" ref="card_name_sei_to">{{ to.name_sei }}</span></div>
							<div style="white-space: nowrap"><span style="display: inline-block" ref="card_name_mei_to">{{ to.name_mei }}</span></div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="comment" class="mt-10" @click="onCommentClick">
				<div v-if="commentEllipsis" class="word-wrap" v-html="$utils.ellipsis(comment, commentEllipsis)"></div>
				<div v-else class="word-wrap">{{ comment }}</div>
			</div>

			<div v-if="created" class="created mt-10">{{ created }}</div>

			<div v-if="isFooterShow" class="sv-card-footer">
				<hr class="mt-15 mb-15" style="margin-left: -10px; margin-right: -10px;"/>

				<div class="horizontal-center">
					<like :count="like" :isLiked="is_liked" @click="onLikeClick"></like>

					<div class="space"></div>

					<div v-if="isEditShow" class="action-button horizontal-center" @click="onEditClick">
						<img :src="require('@/assets/icons/edit.svg')">
						<span>編集</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CommonAvatar from '@/components/CommonAvatar'
import { mapState } from 'vuex'
import Like from '@/components/Like'

export default {
	name: 'CoinCard',
	components: {
		CommonAvatar,
		Like,
	},
	props: {
		isTeam: {
			type: Boolean,
			default: false,
		},
		isMember: {
			type: Boolean,
			default: false,
		},
		isFooterShow: {
			type: Boolean,
			default: true,
		},
		isEditShow: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: '',
		},
		comment: {
			type: String,
			default: '',
		},
		coin: {
			type: Object,
			default: null,
		},
		to: {
			type: Object,
			default: null,
		},
		from: {
			type: Object,
			default: null,
		},
		clickable: {
			type: Boolean,
			default: true,
		},
		created: {
			type: String,
			default: '',
		},
		commentEllipsis: {
			type: Number,
			default: null,
		},
		likeCount: {
			type: Number,
			default: 0,
		},
		isLiked: {
			type: Boolean,
			default: false,
		},
		isShowed: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			like: 0,
			is_liked: false,
		}
	},
	created() {
		this.like = this.likeCount;
		this.is_liked = this.isLiked;
	},
	mounted() {
		this.adjustCardNameFontSizes();
	},
	watch: {
		isShowed: function() {
			this.adjustCardNameFontSizes();
		}
	},
	computed: {
	},
	methods: {
		onLikeClick: async function() {
			let ep = 'present-coin-likes';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { 'present_coin_id': this.id }, true);
				this.$utils.log(res);

				this.like = res.data.like_count;
				this.is_liked = res.data.is_liked;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
			}
		},
		onEditClick: function() {
			this.$emit('edit-click');
		},
		onCommentClick: function() {
			this.$emit('comment-click');
		},
		adjustCardNameFontSizes: function() {
			this.adjustCardNameFontSize(this.$refs.card_name_sei_from, this.$refs.card_name_from);
			this.adjustCardNameFontSize(this.$refs.card_name_mei_from, this.$refs.card_name_from);
			this.adjustCardNameFontSize(this.$refs.card_name_sei_to, this.$refs.card_name_to);
			this.adjustCardNameFontSize(this.$refs.card_name_mei_to, this.$refs.card_name_to);
		},
		adjustCardNameFontSize: function(cardNameElement, parentElement) {
			if (cardNameElement) {
				const step = 0.5;
				while (cardNameElement.clientWidth > parentElement.clientWidth) {
					const fontSize = window.getComputedStyle(cardNameElement).fontSize;
					const adjustedFontSize = (parseFloat(fontSize) - step) + "px";
					cardNameElement.style.fontSize = adjustedFontSize;
					if (window.getComputedStyle(cardNameElement).fontSize == fontSize) {
						// FontSizeが一定値より下がらない場合があるので、調整値設定による変化がなければ処理を抜ける
						this.$utils.log('No change in fontSize, so break.');
						break;
					}
				}
			}
		} 
	},
}
</script>

<style lang="scss">

</style>
